import config from '@/assets/js/config'

export const origin = origin => ({ transformOrigin: origin })
export const showLine = { scaleX: 1 }
export const hideLine = { scaleX: 0 }
export const offset = (duration, offset) => offset * duration
export const createStepTimeline = lineTimelines => {
  const creativityTimeline = new TimelineMax()

  lineTimelines.forEach(timeline => {
    creativityTimeline.add(timeline, 0)
  })

  return creativityTimeline
}
export const isSmallViewport = () => window.matchMedia(`(max-width: ${ config.breakpoints.md + 1 }px)`).matches
export const duration = duration => duration



// WEBPACK FOOTER //
// ./src/assets/js/hero/helpers.js